'use strict';

angular.module('chatEngine.loadingDialog', ['ui.bootstrap'])

.controller('LoadingDialogCtrl', ['$scope', '$modalInstance', 'message',
    function($scope, $modalInstance, message) {
    $scope.message = message;
}])

.factory('LoadingDialog', ['$modal', '$timeout', function($modal, $timeout) {
    var loadingDialog = {};

    loadingDialog.show = function(message) {
        return $modal.open({
            templateUrl: 'views/loading-dialog.html',
            windowClass: 'loading-dialog',
            controller: 'LoadingDialogCtrl',
            backdrop: 'static',
            keyboard: false,
            resolve: {
                message: function() {
                    return message;
                }
            }
        });
    };

    loadingDialog.hide = function(modalInstance) {
        return $timeout(angular.bind(modalInstance, modalInstance.dismiss), 800, false);
    };

    return loadingDialog;
}]);
